// extracted by mini-css-extract-plugin
export var forecast = "Forecast-module--forecast--2tUX6";
export var animateIn = "Forecast-module--animateIn--35XaZ";
export var icon = "Forecast-module--icon--19Os2";
export var title = "Forecast-module--title--GN-qr";